// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	devmode: /localhost/.test(document.location.host)
		? true
		: JSON.parse($ENV.DEVBRANCH),
	endpoint: /localhost/.test(document.location.host) ? null : $ENV.ENDPOINT,
	baseEndpoint: $ENV.ENDPOINT,
	mixpanelToken: '873e2410d626da4367ee965552c634e0',
	// Organization IDs for which Overflow and Basin menu items are hidden
	hideOverflowBasinForOrgIds: ['c8b051cf-d4cd-4c4b-8099-bfbb4d46a02f'],
	lens2Url: 'https://test.next.dryp.live',
	azureLoginUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=89c638be-dc04-48b6-b8b9-1f6adea78b7b&response_type=code&response_mode=form_post&redirect_uri=${encodeURIComponent(
		$ENV.ENDPOINT + '/api/lens/sso/callback/microsoft'
	)}&scope=openid profile User.Read&state=lens1`
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
